import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import noop from 'lodash/noop';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { DatePickerIcon } from '../icons';
import FormLabel from './FormLabel';

const CustomDatePicker = React.forwardRef(
  (
    {
      value,
      onChange = noop,
      id,
      label,
      hasError,
      helpText,
      hint,
      placeholder,
      autoFocus,
      disablePast,
      disableFuture,
      shouldDisableDate,
      minDate,
      variant,
      disabled,
      size = 'medium',
      ...other
    },
    ref,
  ) => {
    const Component = variant === 'datetime' ? DateTimePicker : DatePicker;
    return (
      <FormControl
        disabled={disabled}
        margin="normal"
        {...other}
        error={hasError}
      >
        {label && <FormLabel>{label}</FormLabel>}
        <Component
          disabled={disabled}
          error={hasError}
          inputRef={ref}
          disablePast={disablePast}
          disableFuture={disableFuture}
          shouldDisableDate={shouldDisableDate}
          minDate={
            minDate
              ? moment.isMoment(minDate)
                ? minDate
                : moment(minDate)
              : undefined
          }
          value={
            value ? (moment.isMoment(value) ? value : moment(value)) : null
          }
          onChange={onChange}
          InputProps={{
            placeholder,
          }}
          InputAdornmentProps={{
            sx: { position: 'absolute', right: 14 },
          }}
          slots={{
            openPickerIcon: DatePickerIcon,
          }}
          slotProps={{
            openPickerButton: {
              sx: {
                color: 'text.secondary',
              },
            },
            openPickerIcon: {
              // color: 'text.secondary',
              sx: {
                '& .MuiIconButton-root': {
                  // color: 'text.secondary',
                },
              },
            },
            textField: {
              size,
              sx: {
                '& .MuiInputBase-root': {
                  backgroundColor: 'input.background',
                },
                input: {
                  padding: '6px 12px',
                  '&::placeholder': {
                    color: 'text.subtle',
                    opacity: 1,
                  },
                },
              },
            },
          }}
        />
        {hint && (
          <Typography variant="caption" color="textSecondary">
            {hint}
          </Typography>
        )}
        {hasError && <FormHelperText>{helpText}</FormHelperText>}
      </FormControl>
    );
  },
);

CustomDatePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
  hint: PropTypes.string,
  autoFocus: PropTypes.bool,
  disablePast: PropTypes.bool,
  disableFuture: PropTypes.bool,
  shouldDisableDate: PropTypes.func,
  minDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  variant: PropTypes.oneOf(['datetime', 'date']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default CustomDatePicker;
